import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FlexLayoutModule} from "@angular/flex-layout";
import {SharedModule} from "../shared.module";
import {StripeComponent} from "./stripe.component";
import {NgxStripeModule} from "ngx-stripe";



@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule.withConfig({useColumnBasisZero: false}),
    SharedModule,
    NgxStripeModule,
  ],
  declarations: [StripeComponent],
  exports: [StripeComponent]
})
export class StripeModule { }
